import React, { useEffect } from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { ServiceTypes } from 'constants/ServiceTypes';
import { HotkeyService } from 'services/helper-services/HotkeyService';
import { StyledButton } from './StoreTagButtonStyles';

interface IProps {
  keyCode: number;
  intent: Intent;
  label: string;
  width?: string;
  onHotkeyPressCallback?: () => void;
  onClickCallback?: () => void;
  isDisabled: boolean;
}

type Intent = 'primary' | 'secondary' | 'tertiary' | 'success' | 'warning';

const StoreTagButton: React.FC<IProps> = (props) => {
  const { keyCode, intent, label, width, onHotkeyPressCallback, onClickCallback, isDisabled, ...rest } = props;
  const hotkeyService = useInjection<HotkeyService>(ServiceTypes.HotkeyService);

  const onStored = (event: KeyboardEvent): boolean => {
    if (onHotkeyPressCallback && !isDisabled) {
      event.preventDefault();
      onHotkeyPressCallback();
    }
    return true;
  };

  useEffect(() => {
    hotkeyService.subscribe(keyCode, onStored, 'StoreTagButton');
    return (): void => {
      hotkeyService.unsubscribe('StoreTagButton');
    };
  }, [onHotkeyPressCallback, keyCode, hotkeyService]);

  return (
    <StyledButton
      intent={intent}
      label={label}
      onClick={(): void => onClickCallback && onClickCallback()}
      width={width}
      disabled={isDisabled}
      {...rest}
    />
  );
};

export default StoreTagButton;
